module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadNode),
      expression: "loadNode"
    }],
    attrs: {
      "element-loading-radius": "10"
    }
  }, [_c('a', {
    class: _vm.node.nodeClass
  }, [(_vm.node.type != 2) ? _c('span', {
    staticClass: "company_info"
  }, [(_vm.node.type == 1) ? _c('span', {
    class: [_vm.show ? 'company_ico02' : 'company_ico01'],
    on: {
      "click": _vm.toggleChild
    }
  }) : _vm._e(), _vm._v(" "), (_vm.node.type == 0) ? _c('span', {
    class: [_vm.show ? 'company_ico12' : 'company_ico11'],
    on: {
      "click": _vm.toggleChild
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "node",
    staticClass: "company_name",
    class: [_vm.nodeClickedId === _vm.node.id ? 'nodeActive' : ''],
    attrs: {
      "onselectstart": "return false",
      "data-toggle": "tooltip-tree",
      "data-placement": "bottom",
      "title": _vm.updateInfo
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.click.apply(null, arguments)
      },
      "dblclick": _vm.toggleChild,
      "mouseover": function($event) {
        return _vm.refreshTime($event)
      }
    }
  }, [_vm._v("\n\t        \t\t" + _vm._s(_vm.node.name) + "\n\t        \t\t" + _vm._s(_vm.searching ? '（' + _vm.node.amount + '）' : '') + "\n\t\t\t\t")]), _vm._v(" "), (_vm.node.type != 2) ? _c('em', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "company_menu",
    attrs: {
      "data-toggle": "dropdown"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown_menu02 list-group list01"
  }, [_c('li', {
    on: {
      "click": _vm.refreshNode
    }
  }, [_c('span', [_vm._v("刷新")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.listNode
    }
  }, [_c('span', [_vm._v("一览")])]), _vm._v(" "), (_vm.permission.indexOf('monitorVehicle_panelOpenTrack') == -1) ? _c('li', {
    on: {
      "click": _vm.trackNode
    }
  }, [_c('span', [_vm._v("轨迹")])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.exportNode
    }
  }, [_c('span', [_vm._v("导出")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "bg_color",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openCarFile.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.node.type == 2) ? _c('span', {
    staticClass: "bg_text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addLocation.apply(null, arguments)
      }
    }
  }, [_c('i', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.click.apply(null, arguments)
      }
    }
  }, [(!_vm.checkable) ? _c('span', {
    staticClass: "sp01",
    class: [_vm.nodeClickedId === _vm.node.id ? 'nodeActive' : '']
  }, [_vm._v("\n\t        \t\t" + _vm._s(_vm.node.showFiled1) + "\n\t\t\t\t\t")]) : _c('span', {
    class: [_vm.nodeClickedId === _vm.node.id ? 'nodeActive' : '']
  }, [_vm._v("\n\t        \t\t" + _vm._s(_vm.node.showFiled1) + "\n\t\t\t\t\t")]), _vm._v(" "), (_vm.permission.indexOf('monitorVehicle_panelExpansionPosition') == -1) ? _c('em', {
    attrs: {
      "data-toggle": "tooltip-tree",
      "data-placement": "bottom",
      "title": "轨迹"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addTrack.apply(null, arguments)
      }
    }
  }, [_c('a', {
    staticClass: "company_playback"
  })]) : _vm._e(), _vm._v(" "), _c('em', {
    attrs: {
      "data-toggle": "tooltip-tree",
      "data-placement": "bottom",
      "title": "关注"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addFollow.apply(null, arguments)
      }
    }
  }, [_c('a', {
    staticClass: "company_attention"
  })]), _vm._v(" "), _c('em', [(_vm.checkable) ? _c('input', {
    staticClass: "company_check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.node.checked
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.check.apply(null, arguments)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('i', [_c('span', [_vm._v(_vm._s(_vm.node.showFiled2))]), _vm._v(" "), _c('em', {
    attrs: {
      "data-toggle": "tooltip-tree",
      "data-placement": "bottom",
      "title": "定位"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addLocation.apply(null, arguments)
      }
    }
  }, [_c('a', {
    staticClass: "car_location"
  })]), _vm._v(" "), _c('em', {
    staticClass: "em_text"
  }, [_c('span', [_vm._v(_vm._s(_vm.node.showFiled3))])])])]) : _vm._e()]), _vm._v(" "), (_vm.show) ? _c('ul', {
    staticClass: "ul_line",
    class: _vm.key
  }, [_vm._l((_vm.children), function(child, index) {
    return _c('items', {
      key: index,
      attrs: {
        "index": index,
        "treeType": _vm.treeType,
        "node": child,
        "checkable": _vm.checkable,
        "searching": _vm.searching,
        "searchInput": _vm.searchInput,
        "searchType": _vm.searchType,
        "isCarMoved": _vm.isCarMoved,
        "showCheckbox": _vm.showCheckbox,
        "nodeClickedId": _vm.nodeClickedId
      },
      on: {
        "toggleChild": _vm.handleToggle,
        "refreshNode": _vm.handleRefresh,
        "srchRefresh": _vm.handleSrchRefresh,
        "srchToggle": _vm.handleSrchToggle,
        "listNode": _vm.handleAddVehicles,
        "checkTrace": _vm.handleCheckTrace,
        "exportNode": _vm.handleExport,
        "addFollow": _vm.handleAddFollow,
        "addTrack": _vm.handleAddTrack,
        "addLocation": _vm.handleAddLocation,
        "click": _vm.handleClick,
        "check": _vm.handleCheck
      }
    })
  }), _vm._v(" "), (_vm.showLoadmore) ? _c('div', {
    staticClass: "loadmore",
    on: {
      "click": _vm.loadmore
    }
  }, [_c('span', [_vm._v("加载更多")])]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cee355d0","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Tree/NodeTree.vue
// module id = 1637
// module chunks = 0